import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraAvatar } from '../ensigns/avatar';
import { SpecraIconTile } from '../ensigns/icon-tile';
import { SpecraText } from '../ensigns/typography';
/** Audit/activity event with actor, timestamp, and optional actions. */ export function SpecraActivityRow({ actions, actor, className, description, icon, timestamp, title, ...props }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('flex min-w-0 items-start gap-3 py-3', className),
        ...props,
        children: [
            actor ? /*#__PURE__*/ _jsx(SpecraAvatar, {
                name: actor,
                size: "sm"
            }) : /*#__PURE__*/ _jsx(SpecraIconTile, {
                children: icon ?? '•'
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "min-w-0 flex-1",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-wrap items-start gap-x-3 gap-y-1",
                        children: [
                            /*#__PURE__*/ _jsx(SpecraText, {
                                className: "min-w-0 flex-1 font-medium",
                                size: "caption",
                                children: title
                            }),
                            timestamp ? /*#__PURE__*/ _jsx(SpecraText, {
                                className: "shrink-0 sm:ml-auto",
                                size: "micro",
                                tone: "muted",
                                children: timestamp
                            }) : null
                        ]
                    }),
                    description ? /*#__PURE__*/ _jsx(SpecraText, {
                        as: "div",
                        className: "mt-1",
                        size: "caption",
                        tone: "muted",
                        children: description
                    }) : null,
                    actions ? /*#__PURE__*/ _jsx("div", {
                        className: "mt-2 flex flex-wrap gap-2",
                        children: actions
                    }) : null
                ]
            })
        ]
    });
}
